import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import UserUpdateDialog from "@/v2-backoffice-client/user/update/UserUpdateDialog"

export type UserUpdateMenuItemProps = Omit<ActionMenuItemProps, "onClick"> & {
  user: UserFragment
}

function UserUpdateMenuItem(props: UserUpdateMenuItemProps) {
  const { user, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="pencil"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Update User"}
      </ActionMenu.Item>

      <UserUpdateDialog user={user} open={isOpen} onOpenChange={setIsOpen} />
    </>
  )
}

export default UserUpdateMenuItem
